import { NativeActionsList } from '@wix/editor-platform-host-integration-apis';
import { ContributedPlatformActionsDict } from '../types';
import { presetsActionFactory } from './presetsActionFactory';

export const platformNativeActions: ContributedPlatformActionsDict = {
  [NativeActionsList.presets]: presetsActionFactory,
};
